import { useEffect } from "react";
import { Link } from "react-router-dom";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import { useRecordContext } from "react-admin";

import resources from "../../constants/resources";
import { ADD_CONTENT_ITEM_LABEL } from "../../constants/titleConstants";
import { CONTENT_TYPES } from "../../constants/contentConstants";
import { AddAndOrderButtonStyles } from "../../styles/commonStyles";

const AddContentItemButton = ({
  nextOrder,
  setContentTypeQueryParam,
  currentContentTypeQueryParam,
}) => {
  const record = useRecordContext();
  const contentTypeQueryParam =
    record.content_type === CONTENT_TYPES.survey.id
      ? CONTENT_TYPES.survey.queryParam
      : CONTENT_TYPES.tutorial.queryParam;
  useEffect(() => {
    if (currentContentTypeQueryParam !== contentTypeQueryParam) {
      setContentTypeQueryParam(contentTypeQueryParam);
    }
  }, [currentContentTypeQueryParam]);

  return (
    <AddAndOrderButtonStyles
      variant="text"
      component={Link}
      // eslint-disable-next-line max-len
      to={`/${resources.CONTENT_ITEMS.url}/create?content_id=${record.id}&order=${nextOrder}&ct=${contentTypeQueryParam}`}
      title={ADD_CONTENT_ITEM_LABEL}
      startIcon={<ChatBubbleIcon />}
    >
      {ADD_CONTENT_ITEM_LABEL}
    </AddAndOrderButtonStyles>
  );
};

export default AddContentItemButton;
